import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({
	root: {
		margin: '30px',
	},
	uploadButton: {
		marginTop: '10px',
	},
	warning: {
		backgroundColor: theme.palette.warning.main,
		color: '#FFF',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'space-between',
	},
}));

export const schema = {
	name: {
		presence: { allowEmpty: false, message: 'is required' },
		length: {
			maximum: 64,
		},
	},
	kinds: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	description: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	currentPrice: {
		presence: { allowEmpty: false, message: 'is required' },
		numericality: {
			greaterThan: 0,
			notEven: 'must be evenly divisible by two',
		},
	},
	originalPrice: {
		presence: { allowEmpty: false, message: 'is required' },
		numericality: {
			greaterThan: 0,
			notEven: 'must be evenly divisible by two',
		},
	},
};
